<div class="wrap" (click)="onChangeState()">
  <div class="left">
    <div class="check-mark" [class.checked]="checked"></div>
    <div class="label">{{ i18nLabel | translate }}</div>
  </div>
  <div class="right">
    <ng-container *ngTemplateOutlet="rightSlotTemplate || null"></ng-container>
  </div>
</div>
